import type { ListingFiltersState } from '@/components/listings/search/ListingSearchProvider'
import type { ListingFilterList } from '@/components/listings/search/SearchFilters'

interface IProps {
  filtersState: ListingFiltersState
  filterComponents: ListingFilterList
  updateFilters: (filters: Partial<ListingFiltersState>) => void
  noClose?: boolean
}

export const FiltersList = ({
  filterComponents,
  filtersState,
  updateFilters,
  noClose,
}: IProps) => {
  return (
    <>
      {filterComponents.map((FilterComp) =>
        FilterComp.Applied ? (
          <FilterComp.Applied
            key={FilterComp.label}
            filtersState={filtersState}
            updateFilters={updateFilters}
            noClose={noClose}
          />
        ) : null
      )}
    </>
  )
}
